import React, { Fragment, useContext, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerOne from "../components/DashBoardLayerOne";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { Icon } from "@iconify/react/dist/iconify.js";
import Utils from "../utils/Utils";

import * as Fa from "react-icons/fa";

const HomePageOne = () => {
  const navigate = useNavigate();
  const {
    recentEnquiries,
    tokenData,
    enquiriesHistory,
    todayEnquiries,
    upComingHolidays,
  } = useContext(AppContext);
  const [pending, setPending] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const enquiries = recentEnquiries?.enquiries ?? [];
  const Modified = recentEnquiries?.modified_enquiries ?? [];

  useEffect(() => {
    const pendings =
      Array.isArray(recentEnquiries?.enquiries) &&
      recentEnquiries?.enquiries.length > 0
        ? recentEnquiries.enquiries
            .filter((data) => {
              if (data?.status === "Requested") {
                return data;
              }
            })
            .reverse()
        : [];

    setPending(pendings);
  }, [recentEnquiries]);

  // useEffect(() => {
  //   if (!tokenData) return;
  //   if (tokenData && tokenData?.pluginDomain == "") {
  //     alert();
  //     setShowAlert(true);
  //   } else {
  //     setShowAlert(false);
  //   }
  // }, [tokenData]);

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb pageTitle="Dashboard" title="Home" />
        <div>
          {showAlert && (
            <div
              className="alert alert-danger text-center mx-auto"
              role="alert"
            >
              Domain URL is not available!
            </div>
          )}
        </div>
        <Fragment>
          <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
            <div className="col-lg-3 col-sm-3 col-md-3">
              <div
                className="card shadow-none border bg-gradient-start-4 h-100 cursor-pointer"
                onClick={() => navigate("/table-enquiry-list")}
              >
                <div className="card-body p-20">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div>
                      <p className="fw-medium text-primary-light mb-1">
                        Today's
                      </p>
                      <h6 className="mb-0">{todayEnquiries?.length ?? 0}</h6>
                    </div>
                    <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                      <Icon
                        icon="ic:outline-today"
                        className="text-white text-2xl mb-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-3 col-sm-3 col-md-3">
              <div className="card shadow-none border bg-gradient-start-1 h-100">
                <div className="card-body p-20">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div>
                      <p className="fw-medium text-primary-light mb-1">
                        Recent Reservations
                      </p>
                      <h6 className="mb-0">{enquiries?.length ?? 0}</h6>
                    </div>
                    <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                      <Icon
                        icon="material-symbols:tab-recent"
                        className="text-white text-2xl mb-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-lg-3 col-sm-3 col-md-3">
              <div className="card shadow-none border bg-gradient-start-2 h-100">
                <div
                  className="card-body p-20 cursor-pointer"
                  onClick={() => navigate("/table-enquiry-list?tab=1")}
                >
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div>
                      <p className="fw-medium text-secondary-light mb-1">
                        Pending Reservations
                      </p>
                      <h6 className="mb-0">{pending?.length ?? 0}</h6>
                    </div>
                    <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                      <Icon
                        icon="ic:baseline-edit-calendar"
                        className="text-white text-2xl mb-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-md-3">
              <div className="card shadow-none border bg-gradient-start-3 h-100">
                <div
                  className="card-body p-20 cursor-pointer"
                  onClick={() => navigate("/table-enquiry-list?tab=4")}
                >
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div>
                      <p className="fw-medium text-secondary-light mb-1">
                        Past Enquiries
                      </p>
                      <h6 className="mb-0">{enquiriesHistory?.length ?? 0}</h6>
                    </div>
                    <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                      <Icon
                        icon="bxs:time"
                        className="text-white text-2xl mb-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-lg-7 col-md-8 sol-sm-12">
              <h7 className="sub_title">Upcoming Table reservation holidays</h7>
              <div className="card p-3" style={{ marginTop: "10px" }}>
                <table className="table bordered-table">
                  <thead>
                    <tr>
                      <th>Start Date & Time</th>
                      <th>End Date & Time</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  {upComingHolidays && upComingHolidays.length != 0 ? (
                    upComingHolidays.slice(0, 3).map((exc, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {exc?.startTime
                              ? Utils.parseAndFormat2(exc?.startTime)
                              : "N/A"}
                          </td>
                          <td>
                            {exc?.endTime
                              ? Utils.parseAndFormat2(exc?.endTime)
                              : "N/A"}
                          </td>
                          <td>{exc?.reason}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <div className="placeholder_ text-center">
                          No Holidays are listed
                        </div>
                      </td>
                    </tr>
                  )}
                </table>
                <a className="know_more" href="/reservation-settings">
                  Know more <Fa.FaArrowRight />
                </a>
              </div>
            </div>
          </div>
        </Fragment>
      </MasterLayout>
    </>
  );
};

export default HomePageOne;
